"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_AGENT_MESSAGE_CONSTS = void 0;
exports.PUBLIC_AGENT_MESSAGE_CONSTS = {
    MessageUuidMetadataKey: 'publicAgentMessageUuid',
    MessageUuidsMetadataKey: 'publicAgentMessageUuids',
};
